import styled, { css } from 'styled-components'

import type { AutoCompleteProps } from './types'

export const Container = styled.div`
  position: relative;
`

interface OptionsContainerProps {
  $size: NonNullable<AutoCompleteProps['size']>
  $placement: NonNullable<AutoCompleteProps['placement']>
  $withError: boolean
}

const getOptionsContainerOffset = ($size: OptionsContainerProps['$size']) => {
  if ($size === 'large') return '64px'
  if ($size === 'medium') return '56px'
  if ($size === 'small') return '48px'
}

const getOptionsContainerPlacement = ({ $size, $placement, $withError }: OptionsContainerProps) => {
  if ($placement === 'top') {
    return css`
      bottom: calc(${getOptionsContainerOffset($size)} + ${$withError ? 28 : 0}px);
    `
  }

  if ($placement === 'bottom') {
    return css`
      top: ${() => getOptionsContainerOffset($size)};
    `
  }
}

export const OptionsContainer = styled.div<OptionsContainerProps>`
  position: absolute;
  z-index: 2;
  width: 100%;
  border: 1px solid var(--border-secondary);
  background: var(--bg-primary);
  ${getOptionsContainerPlacement}
`

export const OptionsWrapper = styled.div<{
  $maxHeight: NonNullable<AutoCompleteProps['maxHeight']>
  $withOptionsLabel: boolean
}>`
  padding: var(--space-200) 0;

  ${({ $maxHeight }) => css`
    max-height: ${$maxHeight}px;
    overflow-y: scroll;
  `};

  ${({ $withOptionsLabel }) =>
    $withOptionsLabel &&
    css`
      padding-top: 0;
    `};
`

export const EmptyStateWrapper = styled.div<{
  $height: NonNullable<AutoCompleteProps['maxHeight']>
}>`
  $height: ${({ $height }) => `${$height}px`};
`

export const OptionsLabel = styled.div`
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-200);
  letter-spacing: var(--font-letter-spacing-loose);
  color: var(--text-secondary);
  padding: var(--space-200) var(--space-400) var(--space-100);
`
